import Vue from 'vue'
import App from './App'
import ElementUI from 'element-ui';
Vue.use(ElementUI)
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/init.css';
import '@/assets/css/application.css';
// import '@/assets/js/application.js';
import axios from './utils/axios'
import VueAxios from 'vue-axios'
Vue.use(VueAxios, axios)

const config = require('@/../vue.config');
// console.log(config)

import {removeByIndex,getTime,router_url,screenHeight,hasBtn} from './utils/index'

import {get,post,put,export_blob,del} from './api/index'

import pagination from '@/components/pagination'
Vue.component('pagination',pagination);

// import upload from '@/components/upload';
// Vue.component('upload',upload);
// import uploads from '@/component/s/uploads';

// Vue.component('uploads',uploads);

import header_html from '@/components/header_html'
import footer_html from '@/components/footer_html'
// import latest_property from '@/components/latest_property'

Vue.component('footer_html',footer_html);
Vue.component('header_html',header_html);
// Vue.component('latest_property',latest_property);

// import tinymce from '@/components/tinymce/index.vue'
// Vue.component('tinymce', tinymce)

var table_height=screenHeight();
Vue.prototype.hasBtn = hasBtn
Vue.prototype.removeByIndex = removeByIndex
Vue.prototype.table_height = table_height
Vue.prototype.screenHeight = screenHeight
Vue.prototype.getTime = getTime
Vue.prototype.router_url = router_url
Vue.prototype.$get = get
Vue.prototype.$post = post
Vue.prototype.$put = put
Vue.prototype.$export_blob = export_blob
Vue.prototype.$del = del

import vuescroll from "vuescroll";
Vue.use(vuescroll, {
  ops: {
  	vuescroll:{wheelScrollDuration:200 },
		bar: {background: "#c1c1c1", keepShow: true},
		scrollPanel: {scrollingX: false, easing:'easeInQuad'}
	},
  name: 'vueScroll'
});

import router from './permission' // 权限
new Vue({
	el: '#app',
	router,
	components: {
		App
	},
	template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js